"use client";
import { useState, useEffect } from "react";

import { useSelector, useDispatch } from "react-redux";

import { setDistricts, setTowns } from "@/src/store/filter";

import { getDistricts } from "services/location";

import DistrictDropdown from "../location-checkbox-dropdown/district-dropdown";

import styles from "@/src/components/listing-search/filter-items/styles.module.css";

const DistrictsDropdown = () => {
  const [districts, setDistrictsList] = useState([]);
  const [inputText, setInputText] = useState("");
  const [isListboxOpen, setIsListboxOpen] = useState(false);

  const locationCity = useSelector((state) => state.filter.city);
  const locationDistricts = useSelector((state) => state.filter.districts);
  const locationTowns = useSelector((state) => state.filter.towns);

  const dispatch = useDispatch();

  const fillDistricts = async () => {
    try {
      const arr = [];
      const cityId = locationCity?.id;
      const res = await getDistricts(cityId);
      await res?.result?.map((item) => arr.push({ key: item.id, value: item.name, ...item }));
      setDistrictsList(arr);
    } catch (error) {
      console.error("Error from getCities callback:", error);
    }
  };

  const handleDistrictsChange = (selected) => {
    const newSelectedDistricts = locationDistricts.some((district) => district?.id === selected?.id)
      ? locationDistricts.filter((district) => district.id !== selected.id)
      : [...locationDistricts, selected];
    const districtIds = newSelectedDistricts.map((district) => district.id);
    const newSelectedTowns = locationTowns.filter((selectedTown) => districtIds.includes(selectedTown?.parent?.id));

    dispatch(setTowns(newSelectedTowns));
    dispatch(setDistricts(newSelectedDistricts));
  };

  useEffect(() => {
    if (locationCity && Object.keys(locationCity).length !== 0) {
      fillDistricts();
    }
  }, [locationCity]);

  useEffect(() => {
    if (!isListboxOpen) {
      setInputText("");
    }
  }, [isListboxOpen]);

  const handleInputChange = (event) => {
    setInputText(event.target.value);
  };

  const handleListBoxOpenState = (isOpen) => {
    setIsListboxOpen(isOpen);
  };

  const filteredDataForInput = districts.filter((item) => {
    const lowerDistrictName = item.name.toLocaleLowerCase("tr-TR");
    const lowerInputText = inputText.toLocaleLowerCase("tr-TR");
    return lowerDistrictName.includes(lowerInputText);
  });

  return (
    <div className={styles.dropdownWrapper}>
      <DistrictDropdown
        options={filteredDataForInput}
        placeHolder="İlçe"
        placeHolderClass={styles.dropdownPlaceholder}
        disabled={!locationCity || Object.keys(locationCity).length === 0}
        handleOptionChange={handleDistrictsChange}
        selectedItems={locationDistricts}
        listClass={styles.districtsClass}
        optionClass={styles.optionClass}
        handleInputChange={handleInputChange}
        inputValue={inputText}
        onOpenChange={handleListBoxOpenState}
      />
    </div>
  );
};

export default DistrictsDropdown;
